<template>
    <v-row>
        <v-dialog v-model="imagen" max-width="50%">
      <v-card class="mx-auto" max-width="100%">
            <v-img class="white--text align-end" height="auto"  :src="setImagen"></v-img>
          <v-card-actions>
          <v-col class="text-right">
            <v-btn color="error" @click="imagen=false;">CERRAR</v-btn>
          </v-col>  
          </v-card-actions>
       </v-card>
      </v-dialog>
      <v-col>
        <!-- ini -->
<v-row>
  <v-col class="text-center" cols="12">
          <v-card outlined class="mt-1 py-3"> <span class="ma-2" v-html="presentacion.titulo"></span></v-card>
    </v-col>
     <v-col class="text-center" cols="12">
         <v-card outlined class="mt-1 py-3"> <span class="ma-2" v-html="presentacion.subtitulo"></span></v-card>
    </v-col>
      <v-col cols="4 " class="white">
        <template>
        <!-- Contenido Diapositiva ini -->
          <div  v-for="(item) of presentacion.seccion1" :key="item.id"> 
            <template>
              <v-col cols="">
              <template v-if="item.nombre!=''">  <span class="ma-2" v-html="item.nombre" style="color:#000;font-weight:400;text-align:justify;"></span> </template>
              <template  v-if="item.img_paht!=''"> <v-row class="ma-2" align="center" justify="center">  <v-img :src="rutaservidor+item.img_paht" @click="verImage(item.img_paht)" id="image"></v-img></v-row>  </template> 
              <div class="text-center">
                    <video width="300px" height="200px"  loop  controls v-if="item.vid_paht!=''">
                    <source :src="rutaservidor+item.vid_paht" type="video/mp4" />
                    <source :src="rutaservidor+item.vid_paht" type="video/ogg" />
                    <source :src="rutaservidor+item.vid_paht" type="video/webm" />
                    </video>
              </div>
              <div v-if="item.name_file!=''" class="mb-3">
                   <a :href="rutaservidor+item.file_path" target="_blank">{{item.name_file}}</a>
                </div>
              </v-col>
            </template>
          </div>
        <!-- Contenido Diapositiva end -->
        </template>
      </v-col>
  <v-col cols="4" class="white">
  <template>
    <!-- Contenido Diapositiva ini 2 -->
      <div  v-for="(item) of presentacion.seccion2" :key="item.id"> 
        <template>
          <v-col cols="">
            <template v-if="item.nombre2!=''">  <span class="ma-2" v-html="item.nombre2" style="color:#000;font-weight:400;text-align:justify;"></span> </template>
           <template v-if="item.img_paht2!=''">  <v-img :src="rutaservidor+item.img_paht2" max-width="500" max-height="300" class="mx-auto" @click="verImage(item.img_paht2)" id="image"></v-img> </template> 
             <div class="text-center">
            <video width="300px" height="200px" preload="metadata"  loop  controls v-if="item.vid_paht2!=''">
                    <source :src="rutaservidor+item.vid_paht2" type="video/mp4" />
                    <source :src="rutaservidor+item.vid_paht2" type="video/ogg" />
                    <source :src="rutaservidor+item.vid_paht2" type="video/webm" />
                    </video>
              </div>
              <div v-if="item.name_file2!=''" class="mb-3">
                   <a :href="rutaservidor+item.file_path2" target="_blank">{{item.name_file2}}</a>
                </div>
          </v-col>
        </template>
      </div>
    <!-- Contenido Diapositiva end 2 -->
    </template>
  </v-col>
   <v-col cols="4" class="white">
        <template>
        <!-- Contenido Diapositiva ini -->
          <div class="" v-for="(item) of presentacion.seccion3" :key="item.id"> 
            <template>
              <v-col cols="">
                <template v-if="item.nombre3!=''">  <span class="ma-2" v-html="item.nombre3" style="color:#000;font-weight:400;text-align:justify;"></span> </template>
              <div v-if="item.img_paht3!=''">   <v-img :src="rutaservidor+item.img_paht3" @click="verImage(item.img_paht3)" id="image"></v-img> </div> 
              <video width="300px" height="200px" preload="metadata"  loop  controls v-if="item.vid_paht3!=''">
                    <source :src="rutaservidor+item.vid_paht3" type="video/mp4" />
                    <source :src="rutaservidor+item.vid_paht3" type="video/ogg" />
                    <source :src="rutaservidor+item.vid_paht3" type="video/webm" />
                    </video>
              </v-col>
            </template>
             <div v-if="item.name_file3!=''" class="mb-3">
                   <a :href="rutaservidor+item.file_path3" target="_blank">{{item.name_file3}}</a>
             </div>
          </div>
        <!-- Contenido Diapositiva end -->
        </template>
      </v-col>

</v-row>
<!-- <pre>{{  }}</pre> -->
<!-- end -->
      </v-col>
    </v-row>
</template>

<script>
import axios from "../../../helpers/axios";
    export default {
        name: 'vistacol03',
        props:['presentacion'],
    data() {
    return {
      // rutaservidor:  +'/'API_URL,
      rutaservidor: '/',
    //  msj:false,  text:'', tipo:'',
     api1:[],
     tareas:[],
     tareas2:[],
     imagen:false,
     setImagen:'',
    
    };

  },
 
  mounted() {
     
      //this.acceso2()
    },
      filters: {
    quitarTag: function(string) {
           return string.replace(/<\/?[^>]+>/ig, " "); 
    }
  },


  methods: {

   verImage(image){
     this.setImagen = image
     this.imagen = true
   },

    async  acceso2(){
         try{
           
          let response = await axios.get('/manager/contenido');
          this.api1 = response;
          // console.log('--------------->'+this.api1)
          let api2 = JSON.parse(this.api1.data[0].json_contenido)
          // console.log('______x_____'+JSON.stringify(api2.seccion1))
          let sec1 = api2.seccion1
          // console.log('______x22_____'+JSON.stringify(sec1))

          let sec2 = api2.seccion2
          // console.log('______x223_____'+JSON.stringify(sec2))
          this.tareas = sec1
          // console.log('------> esxxxte'+this.tareas.nombre)
          this.tareas2 = sec2 
          // console.log('------> este'+sec1.nombre)

         }catch(error){
           console.log(error);
         }
              
      },

},

  components: {

  }
}
</script>

<style scoped>
  #image{
  cursor: pointer;
}
</style>